import { GET_AUTHENTICATED } from '../actions/types';

const authenticated = (state = {}, action) => {
  switch (action.type) {
    case GET_AUTHENTICATED:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default authenticated;